// Insurance Demo Steps Configuration
// This file contains all demo steps for pages under /Pages/Insurance/

export const insurancePropertiesSteps = [
  {
    title: "Welcome to Insurance Properties!",
    content: `
      <p class="mb-3">This is your Insurance Properties dashboard where you can get quotes and manage insurance for your rental properties.</p>
      <p>Let's explore the key features together!</p>
    `,
    target: null
  },
  {
    title: "Add Property for Insurance",
    content: `
      <p class="mb-3">Use this <strong>Add Property</strong> button to add properties that need insurance coverage.</p>
      <p>You'll be able to get instant quotes from our trusted insurance provider, Steadily.</p>
    `,
    target: "add-property-btn",
    modalOffset: { x: -40, y: 0 }
  },
  {
    title: "Insurance Properties Overview",
    content: `
      <p class="mb-3">This table shows your properties with insurance information:</p>
      <ul class="list-disc ml-5 space-y-1">
        <li><strong>Address:</strong> Property location</li>
        <li><strong>Size:</strong> Property square footage</li>
        <li><strong>Year Built:</strong> Construction year</li>
        <li><strong>Annual Premium:</strong> Current insurance estimate</li>
      </ul>
    `,
    target: "properties-table"
  },
  {
    title: "Get Insurance Quotes",
    content: `
      <p class="mb-3">Each property has a <strong>Get Quote</strong> button that allows you to:</p>
      <ul class="list-disc ml-5 space-y-1">
        <li>Get an insurance quote instantly</li>
        <li>Have an option to purchase</li>
      </ul>
    `,
    info: "Quotes are provided by licensed insurance partners and are usually available within minutes.",
    target: "get-quote-btn",
    modalOffset: { x: -40, y: 0 }
  },
  {
    title: "Tour Complete!",
    content: `
      <p class="mb-3">🎉 Great job! You now understand how to manage insurance for your properties.</p>
      <p>Remember: You can always get new quotes or update existing coverage using the quote buttons.</p>
    `,
    target: null
  }
]

export const insuranceCreatePropertySteps = [
  {
    title: "Welcome to Add Insurance Property!",
    content: `
      <p class="mb-3">This form helps you add a property to get insurance quotes.</p>
      <p>You can either use an existing property address or enter a new one.</p>
    `,
    info: "Accurate address information ensures better insurance quotes.",
    target: null
  },
  {
    title: "Use Existing Address",
    content: `
      <p class="mb-3">If you've already added this property in the system, you can <strong>use the existing address</strong>.</p>
      <p>This saves time and ensures consistency across your records.</p>
    `,
    target: "use-existing-address",
  },
  {
    title: "Property Address Lookup",
    content: `
      <p class="mb-3">Or, enter your property's <strong>address</strong> using the Google Maps lookup.</p>
      <p>This helps insurance providers assess location-specific risks and rates.</p>
    `,
    info: "Property location significantly affects insurance premiums.",
    target: "address_lookup",
    modalOffset: { x: -40, y: 0 }
  },
  {
    title: "Save Property",
    content: `
      <p class="mb-3">Once you've entered the address, click <strong>Save</strong> to add the property.</p>
      <p>You'll then be able to get insurance quotes for this property.</p>
    `,
    info: "You can edit property details later if needed.",
    target: "save-button",
    modalOffset: { x: -40, y: -40 }
  }
]

export const insuranceEditPropertySteps = [
  {
    title: "Edit Insurance Property",
    content: `
      <p class="mb-3">Update your property information to get more accurate insurance quotes.</p>
      <p>Changes to property details may affect your insurance rates.</p>
    `,
    info: "Keep property information current for the most accurate pricing.",
    target: null
  },
  {
    title: "Owner/Landlord Name",
    content: `
      <p class="mb-3">Enter the <strong>Owner/Landlord Name</strong> for maintenance coordination.</p>
      <p>This contact will receive maintenance notifications and updates.</p>
    `,
    info: "Ensure this contact information is current for effective communication.",
    target: "owner_name",
  },
  {
    title: "Property Address Lookup",
    content: `
      <p class="mb-3">Or, enter your property's <strong>address</strong> using the Google Maps lookup.</p>
      <p>This helps insurance providers assess location-specific risks and rates.</p>
    `,
    info: "Property location significantly affects insurance premiums.",
    target: "address_lookup",
    modalOffset: { x: -40, y: 0 }
  },
  {
    title: "Update Property",
    content: `
      <p class="mb-3">Once you've entered the address, click <strong>Update</strong> to add the property.</p>
      <p>You'll then be able to get insurance quotes for this property.</p>
    `,
    info: "You can edit property details later if needed.",
    target: "save-button",
    modalOffset: { x: -40, y: -40 }
  }
]